import { TEMPLATE_BASE_URL } from '@/global/config'
import { GetLocalStorage } from '../tools/util'
import { HTTP_template } from './http'

// 品牌导入模板
export const Template_url_brands = `${HTTP_template}/Template_BrandImport.xls`

// 品牌禁用
export const Template_url_brandsbatch = `${HTTP_template}/Template_BrandSingleCode.xlsx`

// 批量修改价格模板
export const Template_url_price = `${HTTP_template}/Template_Update_ProductPrice.xls`

// 品牌模块-批量修改产品经理
export const Template_url_brandproductmanager = `${HTTP_template}/Template_BrandUpdateProductManager.xlsx`

// 物料列表模块-批量修改产品经理
export const Template_url_goodsproductmanager = `${HTTP_template}/Template_UpdateProductManager.xlsx`

// 物料列表模块-批量修改执行人
export const Template_url_goodsstockman = `${HTTP_template}/批改执行人模板.xlsx`

// 批量修改毛重
export const Template_url_grossweight = `${HTTP_template}/毛重批改模板.xlsx`

// 修改旧物料编码
export const Template_url_oldproductcode = `${HTTP_template}/旧物料编码批改模板.xlsx`

// 修改货主
export const Template_url_shipperupdate = `${HTTP_template}/货主批改模板.xlsx`

// 修改条形码
export const Template_url_barcodeupdate = `${HTTP_template}/条形码批改模板.xlsx`

// 修改品牌
export const Template_url_brandupdate = `${HTTP_template}/批改物料品牌模板.xlsx`

// 修改四级类目
export const Template_url_categoryupdate = `${HTTP_template}/批改四级类目.xlsx`

// 物料列表模块-批量禁用、推送
export const Template_url_goodsbatch = `${HTTP_template}/Template_ProductSingleCode.xlsx`

// 物料列表模块-批量修改使用组织
export const Template_url_goodsuseorg = `${HTTP_template}/批改使用组织.xlsx`

export const Template_url_purchase = `${HTTP_template}/批改采购员.xlsx`

// 考核人
export const Template_url_assess = `${HTTP_template}/%E5%AF%BC%E5%85%A5%E6%89%B9%E6%94%B9%E8%80%83%E6%A0%B8%E4%BA%BA.xls`

// 加价系数
export const Template_url_priceFactor = `${HTTP_template}/%E5%AF%BC%E5%85%A5%E6%89%B9%E6%94%B9%E5%8A%A0%E4%BB%B7%E7%B3%BB%E6%95%B0.xls`

// 物料库存
export const Template_url_inventoryManagement = `${TEMPLATE_BASE_URL}/srm/upload/%E7%89%A9%E6%96%99%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`

// 商品报备物料导入模板
export const Template_url_filingSheet = `${TEMPLATE_BASE_URL}/srm/model/%E5%95%86%E5%93%81%E6%8A%A5%E5%A4%87%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5.xlsx`

// 供应商询价单列表页导入模板（SCP）
export const Template_url_inquiryImportSCP = `${TEMPLATE_BASE_URL}srm/model/7.5.0SCP%E8%AF%A2%E4%BB%B7%E5%8D%95%E5%AF%BC%E5%85%A5.xlsx`
import { TEMPLATE_BASE_URL } from '@/global/config'
import { GetLocalStorage } from '../tools/util'
import { HTTP_template } from './http'

// 品牌导入模板
export const Template_url_brands = `${HTTP_template}/Template_BrandImport.xls`

// 品牌禁用
export const Template_url_brandsbatch = `${HTTP_template}/Template_BrandSingleCode.xlsx`

// 批量修改价格模板
export const Template_url_price = `${HTTP_template}/Template_Update_ProductPrice.xls`

// 品牌模块-批量修改产品经理
export const Template_url_brandproductmanager = `${HTTP_template}/Template_BrandUpdateProductManager.xlsx`

// 物料列表模块-批量修改产品经理
export const Template_url_goodsproductmanager = `${HTTP_template}/Template_UpdateProductManager.xlsx`

// 物料列表模块-批量修改执行人
export const Template_url_goodsstockman = `${HTTP_template}/批改执行人模板.xlsx`

// 批量修改毛重
export const Template_url_grossweight = `${HTTP_template}/毛重批改模板.xlsx`

// 修改旧物料编码
export const Template_url_oldproductcode = `${HTTP_template}/旧物料编码批改模板.xlsx`

// 修改货主
export const Template_url_shipperupdate = `${HTTP_template}/货主批改模板.xlsx`

// 修改条形码
export const Template_url_barcodeupdate = `${HTTP_template}/条形码批改模板.xlsx`

// 修改品牌
export const Template_url_brandupdate = `${HTTP_template}/批改物料品牌模板.xlsx`

// 修改四级类目
export const Template_url_categoryupdate = `${HTTP_template}/批改四级类目.xlsx`

// 物料列表模块-批量禁用、推送
export const Template_url_goodsbatch = `${HTTP_template}/Template_ProductSingleCode.xlsx`

// 物料列表模块-批量修改使用组织
export const Template_url_goodsuseorg = `${HTTP_template}/批改使用组织.xlsx`

export const Template_url_purchase = `${HTTP_template}/批改采购员.xlsx`

// 考核人
export const Template_url_assess = `${HTTP_template}/%E5%AF%BC%E5%85%A5%E6%89%B9%E6%94%B9%E8%80%83%E6%A0%B8%E4%BA%BA.xls`

// 加价系数
export const Template_url_priceFactor = `${HTTP_template}/%E5%AF%BC%E5%85%A5%E6%89%B9%E6%94%B9%E5%8A%A0%E4%BB%B7%E7%B3%BB%E6%95%B0.xls`

// 物料库存
export const Template_url_inventoryManagement = `${TEMPLATE_BASE_URL}/srm/upload/%E7%89%A9%E6%96%99%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`

// 商品报备物料导入模板
export const Template_url_filingSheet = `${TEMPLATE_BASE_URL}/srm/model/%E5%95%86%E5%93%81%E6%8A%A5%E5%A4%87%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5.xlsx`

// 供应商询价单列表页导入模板（SCP）
export const Template_url_inquiryImportSCP = `${TEMPLATE_BASE_URL}srm/model/7.5.0SCP%E8%AF%A2%E4%BB%B7%E5%8D%95%E5%AF%BC%E5%85%A5.xlsx`
